import React, { useState, useEffect } from "react";
import "./detailpage.css";

import kneeodrapebanner from "../../images/knee-o-drape-banner.jpg";
import kneeone from "../../images/pdpimage/kneeone.jpg";
import kneetwo from "../../images/pdpimage/kneetwo.jpg";
import kneethree from "../../images/pdpimage/kneethree.jpg";
import kneefour from "../../images/pdpimage/kneeone.jpg";

const whatsappNumber = "+919619065205";

const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Need guidance choosing the right drape?</h3>
    <p>Our clinical support team is here to assist you.</p>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Bulk Quote
    </a>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Brochure
    </a>
  </div>
);

const KneeODrape = () => {
  useEffect(() => {
    document.title =
      "Knee O Drape - Precision Draping for Orthopedic Knee Surgery";
  }, []);

  const thumbnails = [kneeone, kneetwo, kneethree, kneefour];
  const [mainImage, setMainImage] = useState(thumbnails[0]);

  return (
    <>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${kneeodrapebanner})`,
        }}
      >
        <h1 className="homepage-hero-title">Knee O Drape</h1>
        <p className="homepage-hero-subtext">
          Precision Draping for Orthopedic Knee Surgery
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Bulk Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>

      {/* Product Overview with Image Gallery */}
      <section className="mw-product-details mw-container">
        <div className="mw-gallery">
          <div className="mw-gallery-main">
            <img
              src={mainImage}
              alt="Knee O Drape"
              className="gallery-main-img"
            />
          </div>
          <div className="mw-gallery-thumbs">
            {thumbnails.map((img, index) => (
              <div
                key={index}
                className={`gallery-thumb-img-box ${
                  mainImage === img ? "active-thumb" : ""
                }`}
                onClick={() => setMainImage(img)}
              >
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        <div className="mw-product-info" id="contact">
          <h2 className="homepage-section-title">Product Overview</h2>
          <p>
            Our Knee O Drapes are specially designed for orthopedic knee
            surgeries, offering a secure surgical field, fluid containment, and
            reinforced fenestration. The circular cut allows easy access to the
            operative site while maintaining a fully sterile perimeter.
          </p>
          <ul className="mw-list">
            <li>Circular (O-type) fenestration with reinforcement</li>
            <li>Fluid collection pouch or barrier film</li>
            <li>Adhesive film for secure placement</li>
            <li>Impervious SMS/SMMS material zones</li>
            <li>EO-sterilized, ready-to-use packs</li>
          </ul>

          <h2 className="homepage-section-title">Technical Specifications</h2>
          <table className="mw-specs-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Material</td>
                <td>SMS/SMMS/Spunlace + PE Reinforcement</td>
              </tr>
              <tr>
                <td>Drape Dimensions</td>
                <td>200 x 250 cm or customizable</td>
              </tr>
              <tr>
                <td>Fenestration</td>
                <td>10–14 cm circular O-cut</td>
              </tr>
              <tr>
                <td>Additional Features</td>
                <td>Fluid barrier film, incise film, adhesive border</td>
              </tr>
              <tr>
                <td>Sterility</td>
                <td>EO Sterilized</td>
              </tr>
              <tr>
                <td>Packaging</td>
                <td>1 piece per pouch, 20 pcs/carton</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Compliance */}
      <section className="mw-compliance">
        <h2 className="homepage-section-title">Certifications & Standards</h2>
        <ul className="mw-cert-list">
          <li>
            <span className="checkmark">✅</span>
            <span>ISO 13485:2016</span>
          </li>
          <li>
            <span className="checkmark">✅</span>
            <span>EN 13795 High Performance</span>
          </li>
          <li>
            <span className="checkmark">✅</span>
            <span>MDR Compliant</span>
          </li>
        </ul>
      </section>

      {/* Footer CTA */}
      <ContactBanner />
    </>
  );
};

export default KneeODrape;
